import { render } from "./ImpressumView.vue?vue&type=template&id=68ad3d04&scoped=true"
import script from "./ImpressumView.vue?vue&type=script&lang=js"
export * from "./ImpressumView.vue?vue&type=script&lang=js"

import "./ImpressumView.vue?vue&type=style&index=0&id=68ad3d04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ad3d04"]])

export default __exports__